import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

// require("dotenv").config();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

    <App />

);



{/* <React.StrictMode>
<App />
</React.StrictMode> */}

//old render from react 17
// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

//React strick mode will have to be turned off for react-beautiful-dnd to work

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
